import { useRentalManagerUserPropertyArchiveV2WebApiHandler_archive } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { MutateOptions } from '@zg-rentals/react-query5';
import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Args } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type ArchivePropertyMutateOptions = MutateOptions<
  void,
  unknown,
  RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Args
>;

/**
 * Archives a property and its dupes via /api/web/v2/users/properties/archive.
 */
export const useArchiveProperty = (
  options?: Parameters<typeof useRentalManagerUserPropertyArchiveV2WebApiHandler_archive>[0],
) => {
  const mutation = useRentalManagerUserPropertyArchiveV2WebApiHandler_archive(options);

  const archiveProperty = (listingAlias: ListingAlias, mutateOptions?: ArchivePropertyMutateOptions) =>
    mutation.mutate({ postData: { listingAlias } }, mutateOptions);

  return { ...mutation, archiveProperty };
};
